export class SecuritySchedule {

  public schedule: boolean;
  public expression: string;

}
